import { useDesktopView } from 'utils/hooks/useDesktopView'

/**
 * Controls whether the desktop responsive layout is active for /pencarian page.
 *
 * Driven by the Toggle SDK key 'pencarian-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport — desktop layout activates at >=768px
 */
export const useSearchDesktopView = () =>
  useDesktopView('pencarian-desktop-view-enabled')
